
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { ProductTagModel } from './Entities.GormCrm.ProductTag';
import { ProductVariantModel } from './Entities.GormCrm.ProductVariant';
import { QuestionnaireQuestionProductModel } from './Entities.GormCrm.QuestionnaireQuestionProduct';
import { Model, ModelProperty } from 'models/Model';


export class ProductModel extends Model<ProductModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'id', type: 'guid', languageString: 'product.property.id', isHidden: true },
		{ name: 'name', type: 'string', languageString: 'product.property.name' },
		{ name: 'active', type: 'boolean', languageString: 'product.property.active' },
		{ name: 'description', type: 'string', languageString: 'product.property.description' },
		{ name: 'terms', type: 'string', languageString: 'product.property.terms' },
		{ name: 'allowedDiscount', type: 'number', languageString: 'product.property.allowedDiscount' },
		{ name: 'created', type: 'Date', languageString: 'product.property.created', isHidden: true },
		{ name: 'deleted', type: 'Date', languageString: 'product.property.deleted', isHidden: true },
		{ name: 'creationFee', type: 'number', languageString: 'product.property.creationFee' },
		{ name: 'autoRenew', type: 'boolean', languageString: 'product.property.autoRenew' },
		{ name: 'requiredProductId', type: 'guid', languageString: 'product.property.requiredProductId' },
		{ name: 'groupByVariantAndParentOnOrder', type: 'boolean', languageString: 'product.property.groupByVariantAndParentOnOrder' },
		{ name: 'accountingPlanSetupId', type: 'guid', languageString: 'product.property.accountingPlanSetupId' },
		{ name: 'quaterlyPeriodPriceIncreasePercent', type: 'number', languageString: 'product.property.quaterlyPeriodPriceIncreasePercent' },
		{ name: 'yearlyPeriodPriceIncreasePercent', type: 'number', languageString: 'product.property.yearlyPeriodPriceIncreasePercent' },
		{ name: 'commissionDisabled', type: 'boolean', languageString: 'product.property.commissionDisabled' },
		{ name: 'inverseRequiredProduct', type: 'ProductModel[]', languageString: 'product.property.inverseRequiredProduct', isHidden: true, isArray: true, isObject: true, new: () => { return new ProductModel }, properties: () => { return ProductModel.classProperties } },
		{ name: 'productTags', type: 'ProductTagModel[]', languageString: 'product.property.productTags', isHidden: true, isArray: true, isObject: true, new: () => { return new ProductTagModel }, properties: () => { return ProductTagModel.classProperties } },
		{ name: 'productVariants', type: 'ProductVariantModel[]', languageString: 'product.property.productVariants', isHidden: true, isArray: true, isObject: true, new: () => { return new ProductVariantModel }, properties: () => { return ProductVariantModel.classProperties } },
		{ name: 'questionnaireQuestionProducts', type: 'QuestionnaireQuestionProductModel[]', languageString: 'product.property.questionnaireQuestionProducts', isHidden: true, isArray: true, isObject: true, new: () => { return new QuestionnaireQuestionProductModel }, properties: () => { return QuestionnaireQuestionProductModel.classProperties } },
		{ name: 'requiredProduct', type: 'ProductModel', languageString: 'product.property.requiredProduct', isHidden: true, isObject: true, new: () => { return new ProductModel }, properties: () => { return ProductModel.classProperties } },
		{ name: 'requiredProducts', type: 'ProductModel[]', languageString: 'product.property.requiredProducts', isHidden: true, isArray: true, isObject: true, new: () => { return new ProductModel }, properties: () => { return ProductModel.classProperties } }
	];
	[key: string]: any;
	
	public id?: string;
	public name: string;
	public active: boolean;
	public description: string;
	public terms: string;
	public allowedDiscount: number;
	public created?: Date;
	public deleted?: Date;
	public creationFee?: number;
	public autoRenew: boolean;
	public requiredProductId?: string;
	public groupByVariantAndParentOnOrder: boolean;
	public accountingPlanSetupId?: string;
	public quaterlyPeriodPriceIncreasePercent: number;
	public yearlyPeriodPriceIncreasePercent: number;
	public commissionDisabled: boolean;
	public inverseRequiredProduct: ProductModel[];
	public productTags: ProductTagModel[];
	public productVariants: ProductVariantModel[];
	public questionnaireQuestionProducts: QuestionnaireQuestionProductModel[];
	public requiredProduct?: ProductModel;
	public requiredProducts: ProductModel[];
    
	constructor(){
		super();
		this.id = undefined;
		this.name = '';
		this.active = false;
		this.description = '';
		this.terms = '';
		this.allowedDiscount = 0;
		this.created = undefined;
		this.deleted = undefined;
		this.creationFee = undefined;
		this.autoRenew = false;
		this.requiredProductId = undefined;
		this.groupByVariantAndParentOnOrder = false;
		this.accountingPlanSetupId = undefined;
		this.quaterlyPeriodPriceIncreasePercent = 0;
		this.yearlyPeriodPriceIncreasePercent = 0;
		this.commissionDisabled = false;
		this.inverseRequiredProduct = [];
		this.productTags = [];
		this.productVariants = [];
		this.questionnaireQuestionProducts = [];
		this.requiredProduct = undefined;
		this.requiredProducts = [];
		
	}
	getProperties(){
		return ProductModel.classProperties;
	}
}

